module.exports = __webpack_public_path__ + "static/media/181CO213.a2d89283.jpg";